import type { VueI18n } from 'vue-i18n';
import type { Ref } from 'vue';

export const I18nService = Symbol.for('I18nService');

export interface I18nService {
    locale: Ref<VueI18n['locale']>;
    t: VueI18n['t'];
    te: VueI18n['te'];
    /** 将业务模块文案动态合并到指定语言。 */
    mergeLocaleMessage: VueI18n['mergeLocaleMessage'];
}
